import * as React from "react";

const IconPaginationDots: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4" fill="currentColor"><rect width="15" height="3" x=".5" y=".5" fill="none" stroke="#999"/></svg>;
};

export default React.memo(IconPaginationDots);
